import validate from "/vercel/path0/packages/ddc-giving-circle/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.17.0_@vue+compiler-sfc@3_k5isdyixk7v2ifub4acgrocs7e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/packages/ddc-giving-circle/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.17.0_@vue+compiler-sfc@3_k5isdyixk7v2ifub4acgrocs7e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "authenticated-donor": () => import("/vercel/path0/packages/ddc-giving-circle/app/middleware/authenticated-donor.ts"),
  "require-staff": () => import("/vercel/path0/packages/ddc-giving-circle/app/middleware/require-staff.ts")
}